import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import moment from 'moment'
const { WizSpin, WizCard, WizForm, WizRow, WizCol, WizButton, Wizmessage } = component_tool
const { WizContainer, WizFileUpload, WizOssUpload } = framework_tool
const { Session } = utils_tool

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/coach/send') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('coachSend', record)
        } else {
            record = Session.get('coachSend') || {}
        }
    }
    return record
}


class CoachSend extends WizContainer {

    componentName = 'CoachSend'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record,
            imgs: record.promiseFileIdList || [],
            timestamp: new Date().getTime()
        }
    }

    _onSub = () => {
        const { processContentId } = this.state.record
        this.refs.form.validateFields((err, values) => {
            if (!err) {
                let { id, tutorDate, tutorFileId, promiseFileIdList, reformFileId } = values
                let params = {
                    id,
                    tutorDate: tutorDate.format('YYYY-MM-DD 00:00:00'),
                    tutorFileId: tutorFileId.map(tutor => tutor.fileId)[0],
                    reformFileId: reformFileId.map(reform => reform.fileId)[0],
                    promiseFileIdList: promiseFileIdList.map(promise => promise.fileId),
                    tutorContentId: processContentId
                }
                this.doAction({
                    path: 'counselingProcess/coachProcessSend',
                    payload: {
                        key: 'coachProcessSend@' + processContentId,
                        apiParams: params
                    }
                })
            }
        })
    }

    propsAndStateOnChange = {
        save: this._saveOnChange.bind(this)
    }

    _saveOnChange(nextProps, nextState) {
        if (nextProps.save.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('goBack')
        } else {
            wizNotice.error(nextProps.save.msg)
        }
    }

    _renderFooter = () => {
        return (
            <WizRow className='form-btns row-item'>
                <WizCol span={24}>
                    <WizButton type='primary' onClick={() => this._onSub()}>{'确认'}</WizButton>
                </WizCol>
            </WizRow>
        )
    }

    render() {
        let { counselingProcessLoading } = this.props
        let { record, imgs } = this.state
        if (record.tutorDate) {
            record.tutorDate = moment(record.tutorDate)
        } else {
            record.tutorDate = undefined
        }
        let columns = [{
            name: 'id',
            dataIndex: 'id',
            formItem: {
                type: 'hidden'
            }
        }, {
            title: '辅导日期',
            name: 'tutorDate',
            dataIndex: 'tutorDate',
            formItem: {
                type: 'date',
                rules: [{ required: true, message: '请选择辅导日期' }]
            }
        }, {
            title: '辅导报告',
            name: 'tutorFileId',
            dataIndex: 'tutorFileId',
            formItem: {
                type: 'custom',
                render: (r, f) => {
                    const { getFieldDecorator } = f
                    let initialValue = []
                    if (r && r.tutorFileId && r.tutorFileId != -1) {
                        initialValue = [{ fileId: r.tutorFileId }]
                    }
                    return getFieldDecorator('tutorFileId', {
                        initialValue,
                        rules: [{ required: true, message: '请上传辅导报告' }]
                    })(
                        <WizFileUpload
                            key='tutorFile'
                            accept={'.ppt, .pptx, .pdf'}
                            listType={'text'}
                            limit={-1}
                            progress={{
                                strokeColor: { '0%': '#108ee9', '100%': '#87d068' },
                                strokeWidth: 3,
                                format: percent => `${parseFloat(percent.toFixed(2))}%`,
                            }}
                        />
                    )
                }
            }
        }, {
            title: '后续承诺卡',
            name: 'promiseFileIdList',
            formItem: {
                type: 'custom',
                render: (r, f) => {
                    const { getFieldDecorator } = f
                    let children = imgs && imgs.length >= 10 ? null : <WizButton>上传图片</WizButton>
                    return getFieldDecorator('promiseFileIdList', {
                        initialValue: r && r.promiseFileIdList ? r.promiseFileIdList.map(fileId => {
                            return { fileId, url: getOssFilePath(fileId), uid: new Date().getTime() + fileId }
                        }) : [],
                        rules: [{ required: true, message: '请选择后续承诺卡' }]
                    })(
                        <WizOssUpload
                            accept={'.jpg, .jpeg, .png'}
                            listType={'picture-card'}
                            uploadType={'activityPart'}
                            onChange={(files) => this.setState({ imgs: files, timestamp: new Date().getTime() })}
                            children={children}
                        />
                    )
                }
            }
        }, {
            title: '整改计划',
            name: 'reformFileId',
            dataIndex: 'reformFileId',
            formItem: {
                type: 'custom',
                render: (r, f) => {
                    const { getFieldDecorator } = f
                    let initialValue = []
                    if (r && r.reformFileId && r.reformFileId != -1) {
                        initialValue = [{ fileId: r.reformFileId }]
                    }
                    return getFieldDecorator('reformFileId', {
                        initialValue,
                        rules: [{ required: true, message: '请上传整改计划' }]
                    })(
                        <WizFileUpload
                            key='reformFile'
                            accept={'.zip, .xls, .xlsx, .rar'}
                            listType={'text'}
                            limit={-1}
                            progress={{
                                strokeColor: { '0%': '#108ee9', '100%': '#87d068' },
                                strokeWidth: 3,
                                format: percent => `${parseFloat(percent.toFixed(2))}%`,
                            }}
                        />
                    )
                }
            }
        }]
        let formProps = {
            ref: 'form',
            columns,
            record,
            preview: null,
            footer: this._renderFooter(),
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            },
            style: { maxWidth: '100%', width: '100%' }
        }
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <WizCard title='下发辅导'>
                    <WizForm {...formProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId } = findParamRecord(ownProps.history)
    const save = modelUtils.getModelEntity(counselingProcess, 'coachProcessSend@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        save,
        ...loading
    }
}

export default connect(mapStateToProps)(CoachSend)


